import { Paginated } from 'types/api';

import { instance } from 'utils/api';

export type NotificationRow = {
  id: number;
  read: boolean;
  // jsonb payload: {title, body, appointmentId, ...}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body: Record<string, any>;
  createdAt: string;
};

// GET /notifications — 1-based Paginated envelope.
// `read` filter: the BE DTO's @Type(() => Boolean) coerces the query string
// 'false' to true, so read=false cannot reach the BE correctly until the
// transform is fixed (flag-back #8). The param is sent per the intended
// contract regardless.
export const fetchNotifications = async (params: {
  page?: number;
  limit?: number;
  read?: boolean;
}): Promise<Paginated<NotificationRow>> => {
  const res = await instance.get<Paginated<NotificationRow>>('notifications', {
    params
  });

  return res.data;
};

export const fetchUnreadCount = async (): Promise<number> => {
  const res = await instance.get<{ count: number }>(
    'notifications/unread-count'
  );

  return res.data.count;
};

export const markNotificationRead = (id: number) =>
  instance.put(`notifications/${id}/read`);

export const removeNotification = (id: number) =>
  instance.delete(`notifications/${id}`);
